const FILE_MEDIA_DURATION_KEY = "__shark_media_duration_seconds";

function normalizeDurationSeconds(durationSeconds) {
  const normalized = Number(durationSeconds);
  if (!Number.isFinite(normalized) || normalized <= 0) {
    return null;
  }
  return Number(normalized.toFixed(3));
}

export function setFileMediaDuration(file, durationSeconds) {
  if (!file || typeof file !== "object") {
    return file;
  }

  const normalized = normalizeDurationSeconds(durationSeconds);
  if (normalized === null) {
    return file;
  }

  try {
    Object.defineProperty(file, FILE_MEDIA_DURATION_KEY, {
      value: normalized,
      writable: true,
      configurable: true,
    });
  } catch (error) {
    try {
      file[FILE_MEDIA_DURATION_KEY] = normalized;
    } catch (assignError) {}
  }

  return file;
}

export function getFileMediaDuration(file) {
  if (!file || typeof file !== "object") {
    return null;
  }

  return normalizeDurationSeconds(file[FILE_MEDIA_DURATION_KEY]);
}

export function getFirstFileMediaDuration(files) {
  if (!Array.isArray(files) || files.length === 0) {
    return null;
  }

  for (const file of files) {
    const duration = getFileMediaDuration(file);
    if (duration !== null) {
      return duration;
    }
  }

  return null;
}
